import { useTranslation } from 'react-i18next';
import { MessageSquarePlus } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useUpdateRequests } from '../../../hooks/useEqmsDocuments';
import { UpdateRequestCard } from './UpdateRequestCard';

/** The requester's own requests and the owners' decisions; hidden until there is one. */
export function MyUpdateRequests({ documentId }: { documentId?: string }) {
  const { t } = useTranslation('qms');
  const query = useUpdateRequests({ scope: 'mine', documentId });
  const requests = query.data?.requests ?? [];
  if (!requests.length) return null;
  return (
    <Card className="border-slate-200 shadow-sm">
      <CardHeader className="border-b border-slate-100">
        <CardTitle className="flex items-center gap-2 text-base">
          <MessageSquarePlus className="h-4 w-4 text-teal-700" />
          {documentId ? t('updateRequests.documentMine') : t('updateRequests.mineTitle')}
        </CardTitle>
        <p className="text-xs text-slate-500">{t('updateRequests.mineDescription')}</p>
      </CardHeader>
      <CardContent className="space-y-3 p-5">
        {requests.map((request) => <UpdateRequestCard key={request.id} request={request} mode="requester" showDocument={!documentId} />)}
      </CardContent>
    </Card>
  );
}
